import $ from 'jquery';
import InfiniteAjaxScroll from '@webcreate/infinite-ajax-scroll';

function interactWithMediaSwiper() {
  var pagerContainer = $('.js-media-container');
  $(document).on('click', '.js-swiper-expander__toggle', function (e) {
    e.stopPropagation();
    var parentElement = $(this).parent();
    parentElement.toggleClass('expanded');
  }); 
  
  if(pagerContainer.length) {
    let ias = new InfiniteAjaxScroll('.js-media-container', {
      item: '.media-card',
      next: '.pager__item--next a',
      prev: '.prev',
      pagination: '.js-pager__items',
    });
  }

}

export default interactWithMediaSwiper